import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const STEPS = [
  {
    num: '1',
    title: 'Create or Join a League',
    desc: 'Start your own league and invite friends, or browse public leagues and join with one tap.',
  },
  {
    num: '2',
    title: 'Make Your Picks',
    desc: 'Pick the winner of every match before it kicks off. Group stage, Round of 32, all the way to the Final.',
  },
  {
    num: '3',
    title: 'Earn Points & Bonus',
    desc: 'Score points for every correct pick. Be the only one in your league to get it right and earn a 50% bonus.',
  },
  {
    num: '4',
    title: 'Climb the Leaderboard',
    desc: 'Watch the standings update in real time as results come in throughout the tournament.',
  },
];

const STATS = [
  { value: '48', label: 'Teams' },
  { value: '12', label: 'Groups' },
  { value: '104', label: 'Matches' },
  { value: '39', label: 'Days of Action' },
];

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="land-page">

      {/* ── Nav ── */}
      <nav className="land-nav">
        <span className="land-nav-logo display-font">World Cup Pick'em</span>
        <div className="land-nav-actions">
          <button className="land-nav-btn land-nav-btn--ghost" onClick={() => navigate('/login')}>
            Sign In
          </button>
          <button className="land-nav-btn land-nav-btn--solid" onClick={() => navigate('/login?tab=signup')}>
            Sign Up Free
          </button>
        </div>
      </nav>

      {/* ── Hero ── */}
      <section className="land-hero">
        <div className="land-hero-inner">
          <div className="land-hero-badge">2026 FIFA World Cup · June 11 – July 19</div>
          <h1 className="land-hero-title display-font">
            Every match matters.
          </h1>
          <p className="land-hero-sub">
            The free pick 'em league for the biggest football tournament on the planet.
            104 matches. 48 teams. One champion. Can you guess who it'll be?
          </p>
          <div className="land-hero-ctas">
            <button className="land-cta-btn land-cta-btn--primary" onClick={() => navigate('/login?tab=signup')}>
              Create Free Account
            </button>
            <button className="land-cta-btn land-cta-btn--secondary" onClick={() => navigate('/login')}>
              Sign In
            </button>
          </div>
        </div>
      </section>

      {/* ── Stats bar ── */}
      <section className="land-stats">
        {STATS.map((s) => (
          <div key={s.label} className="land-stat">
            <span className="land-stat-value display-font">{s.value}</span>
            <span className="land-stat-label">{s.label}</span>
          </div>
        ))}
      </section>

      {/* ── How to Play ── */}
      <section className="land-section">
        <div className="land-section-inner">
          <h2 className="land-section-title">How It Works</h2>
          <div className="land-steps">
            {STEPS.map((step) => (
              <div key={step.num} className="land-step">
                <div className="land-step-num display-font">{step.num}</div>
                <div className="land-step-content">
                  <div className="land-step-title">{step.title}</div>
                  <div className="land-step-desc">{step.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA banner ── */}
      <section className="land-cta-section">
        <div className="land-cta-inner">
          <h2 className="land-cta-title display-font">Ready to Play?</h2>
          <p className="land-cta-sub">Free to join. Tournament starts June 11.</p>
          <button
            className="land-cta-btn land-cta-btn--primary land-cta-btn--large"
            onClick={() => navigate('/login?tab=signup')}
          >
            Get Started — It's Free
          </button>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="land-footer">
        <span className="land-footer-copy">© 2026 World Cup Pick'em</span>
        <div className="land-footer-links">
          <button className="land-footer-link" onClick={() => navigate('/blog')}>Blog</button>
          <span className="land-footer-sep">·</span>
          <button className="land-footer-link" onClick={() => navigate('/terms')}>Terms of Service</button>
          <span className="land-footer-sep">·</span>
          <button className="land-footer-link" onClick={() => navigate('/privacy')}>Privacy Policy</button>
        </div>
      </footer>

    </div>
  );
}
